/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export { IUserProfileDataService } from "./IUserProfileDataService";
export { IUserProfileMapper } from "./IUserProfileMapper";
export { UserProfileDataService } from "./UserProfileDataService";
export { UserProfileMapper } from "./UserProfileMapper";
